<script>
	import Module from '../components/Module.vue'

	export default {
		data: function(){
			return {
				name: 'MultiChoiceContainer'
			}
		},
			components:{
				Module
			}
	}
</script>

<template>
	<Module topColor="#E74C3C" bottomColor="#0B735F">
		<span slot="title" class="section_name">RANDOM OPTION</span>
		<span slot="description" class="section_text">Don't have matchsticks and want to know who's paying for the beers? Add as many options as you want and roll!</span>
		<div slot="action">
			<span>LET'S ROLL! <!-- <span id="exclamation_mark">!</span> --></span>
		</div>
	</Module>
</template>